module.exports = __webpack_public_path__ + "img/fingerprint_capture_splash.dbd4aa40.jpg";